import { createContext } from 'react';

import { getUrlParameter } from '../helpers/url';

export const ShopContext = createContext(getUrlParameter('shop') || '');
